import axios from '../shared/axios';
import Lang from 'lang.js';

window.axios = axios;

// The jobsite only calls the content API, which authenticates with the bearer token below. Without
// credentials the API's wildcard answer is enough, so a jobsite on an origin we don't know still works.
window.axios.defaults.withCredentials = false;

window.lang = new Lang({
    locale: document.documentElement.lang,
    messages: Jobtoolz.translations
});

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'Accept-Language': window.lang.locale
};

if (
	(typeof Jobtoolz != 'undefined') &&
	(typeof Jobtoolz.api != 'undefined') &&
	(typeof Jobtoolz.api.token != 'undefined')
) {
	window.axios.defaults.headers.common.Authorization = 'Bearer ' + Jobtoolz.api.token;
}
